import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Header from './Components/header.js';
import Resource from './Components/Resource.js';
import './CSS/app.css';
import QuestionTotal from './Components/QuestionTotal';
import { get, getContent, nextQuestion, previousQuestion, fixImgs, fixResPath, fixImgSize, getUrlParams, responsiveTables, windowScroll, closeResourcePlayer, toggleResourcePlayer } from './lib/functions.js';
import Options from './Components/Options.js';
import ModalPrint from './Components/ModalPrint';
import Summary from './Components/Summary';
import Content from './Components/Content';
import Button from 'react-bootstrap/Button';
import Title from './Components/Title';
import TabTitle from './Components/TabTitle';

class App extends Component {
  constructor() {
    super();
    this.state = {
      isLoading : true,
      hasError : false,
      missingContent: false,
      brand : "",
      subject: "",
      subjectTitle : "",
      qComplete : "",
      questionCount : "",
      questionList : [],
      showq : 1,
      showm : 0,
      showe : 0,
      shown : 0,
      showr : 0,
      types : 0,
      currentQuestion : "",
      option : "",
      allContent : [],
      index : [],
      school : "",
      docID : "",
      liveResource: "",
    }
    this.switchOption = this.switchOption.bind(this);
  }

  componentDidMount() { 
    const docID = getUrlParams();
    if (docID === false) { 
      this.setState({ 
        hasError: true,
        isLoading : false
      });
    } else { 
      get(docID, this.getDocument);
      this.setState({
        docID
      }) 
    }
  }
  
  componentDidUpdate() {
    windowScroll(); 
    fixImgSize();
    responsiveTables();
  }

  getDocument = async (data) => { //err
    if (data.err) {
      this.setState({ 
        hasError: true
      });
    } else {
      const qList = data.questionlist.split(",");
      const qlistFld = data.index.map(x => x.fld);
      const qComp = Object.values(JSON.parse(data.qcomplete)).map(x => x.fil);
      const obj = {
        brand : data.brand,
        documentName : data.documentname,
        subject : data.subject,
        subjectTitle : data.subjecttitle,
        qComplete : JSON.parse(data.qcomplete),
        questionCount : data.questioncount,
        questionList : qList,
        questionListFolders : qlistFld,
        showq : data.showq,
        showm : data.showm,
        showe : data.showe,
        shown : data.shown,
        showr : data.showr,
        types : data.types,
        index : data.index,
        allContent : [],
        currentQuestion : "",
        option : "question",
        school: data.school,
        summaryIndex : [],
      }

      try {
        const requests = await this.getQuestionList(qlistFld, qComp);
        obj.allContent = requests.map(item => fixImgs(item.data));
        obj.index.map(item => fixResPath(item));
        
        //this for loop maps the summary and resources into the correct order
        for (let i = 0; i < qList.length; i++) {
          let ix = this.getIndexwithVal(obj.index, "qidclean", qList[i]);
          obj.summaryIndex.push(data.index[ix]);
          obj.index.splice(i, 0, data.index[ix]);
        } 

        //this for loop maps the resources to the correct questions
        /*for (let i=0; i < qComp.length; i++) {
          let t = qComp[i];
          let q = obj.index[i]["qidclean"];
          if (t !== q) {
            let tempOB;
            for (let [index, value] of Object.entries(obj.index)) {
              if(value["qidclean"] === t) {
                tempOB = obj.index[index]
                obj.index.splice(i, 0, tempOB)
              }
            }
          }
        }*/

        obj.currentQuestion = 0;
        this.setState(Object.assign({},obj));
        this.setState({isLoading : false})
      }
      catch(e) {
        this.setState({ 
          missingContent: true,
          isLoading : false
        });
      }
    }
  }

  getIndexwithVal = (array, attr, value) => {
    if (array) {
      for (var i = 0; i < array.length; i++) {
        if (array[i][attr] === value) {
          return i;
        }
      }
    }
  }

  getQuestionList = (qlistFld, questions) => {
    const promises = questions.map((file, index) => {
      return getContent(qlistFld[index], file.toUpperCase())
    })
    return Promise.all(promises)
  }
  
  switchOption(e, index) {
    if (e==="") {
      this.handleNextQuestion();
    } else { 
      closeResourcePlayer();
      let optionClick = e.currentTarget.dataset.id;
      if (optionClick === "resources") {
        toggleResourcePlayer();
      } else {
        
      }
      if (optionClick !== this.state.option) {
        this.setState({
          option : optionClick
        })
      }
    }
  }
  
  handlePreviousQuestion = () => {
    let content = this.state.allContent.length ? this.state.allContent : "";
    let option = this.state.option;
    let currentQuestion = this.state.currentQuestion;
    let qlist = this.state.questionList;
    let temp;

    if (currentQuestion === 0) {
      currentQuestion = qlist.length - 1;
      temp = content[currentQuestion][option];
    } else {
      temp = content[currentQuestion - 1][option];
    }
    if (temp === "") {
      this.setState({
        currentQuestion: previousQuestion(this.state.questionList, this.state.currentQuestion),
        option: "question"
      });
    } else {
      this.setState({
        currentQuestion: previousQuestion(this.state.questionList, this.state.currentQuestion)
      });
    }
  };

  handleNextQuestion = () => {
    let content = this.state.allContent.length ? this.state.allContent : "";
    let option = this.state.option;
   	let currentQuestion = this.state.currentQuestion;
	  let qlist = this.state.questionList;
	  let temp;

    if (currentQuestion + 1 === qlist.length) {
      temp = content[0][option]; 
      } else {
        temp = content[currentQuestion + 1][option];
      }
	    if (temp === "") {
	      this.setState({
	        currentQuestion: nextQuestion(this.state.questionList, this.state.currentQuestion),
          option: "question"
        });
	    } else {
	      this.setState({
        currentQuestion: nextQuestion(this.state.questionList, this.state.currentQuestion)
      });
    } 
  };

  sum = (showm, shown, showr, showe ) => {
    let result = showm + shown + showr + showe;
    return result;
  }

   render() {
     const {isLoading} = this.state;
     if (isLoading) {
      return (
        <div id="loader" className="d-flex justify-content-center">
          <div className="spinner-border" role="status">
            <span className="sr-only">Loading...</span>
          </div>
      </div>
      )
     } else if (this.state.hasError === true) {
      return (
        <div>
          <p className="error-message error-Header">Sorry!</p>
          <p className="error-message">
            The URL you specified does not point to a valid document.
            Please check your URL and try again.
          </p>
        </div>
      )
     } else if (this.state.missingContent === true) {
       return (
         <div className="error-message">
            <img className="content-error-image" src={require("./images/retrieval-error-tbep.png")} alt=""></img>
            <p>
              Oops! This document hasn't been found. Please check the Viewer link and try again - or contact our support team at:
            </p> 
            <a href="https://support.testbase.co.uk/" target="_blank" rel="noopener noreferrer">Testbase</a> <br></br>
            <a href="https://support.exampro.co.uk/" target="_blank" rel="noopener noreferrer">Exampro</a>
         </div>
       )
     } else {
       return (
         <div className={`${this.state.brand} ${this.state.subject}`}>
        <ModalPrint 
             showq={this.state.showq}
             showm={this.state.showm}
             showe={this.state.showe}
             shown={this.state.shown}
             docID={this.state.docID}
             brand={this.state.brand}/>
        <div className="header-container">
          <Header brand={this.state.brand}></Header>
          <Title title={this.state.documentName}
            brand={this.state.brand}
            school={this.state.school}/>
          <Options/>
        </div>
        <QuestionTotal questionCount={this.state.questionCount}
          brand={this.state.brand}
          title={this.state.documentName}
          nextQuestion={this.handleNextQuestion}
          previousQuestion={this.handlePreviousQuestion}
          currentQuestion={this.state.currentQuestion}/>

        <TabTitle title={this.state.option}/>
        <div id="content" className="viewer-content">
          <Content 
            displayContent={this.state.allContent.length ? this.state.allContent[this.state.currentQuestion] : ""}
            option = {this.state.option}
            resourceContent = {this.state.index ? this.state.index[this.state.currentQuestion] : ""}
            subject = {this.state.subject}
            nextQuestion={this.handleNextQuestion}
            previousQuestion={this.handlePreviousQuestion}
            />
          <Resource
          resourceContent = {this.state.index ? this.state.index[this.state.currentQuestion] : ""}
          />
        </div>
        <Summary
          subjectTitle={this.state.subjectTitle}
          title={ this.state.documentName }
          summary={this.state.summaryIndex.length ? this.state.summaryIndex : ""}
          questionCount={this.state.questionCount} />
          

          
          <div className="bottom-buttons">
          <Button className={`${this.state.brand} nav-buttons`} data-id="question" onClick={this.switchOption} disabled={this.state.showq === 1 ? false : this.sum(this.state.showm, this.state.shown, this.state.showr, this.state.showe) === 0 ? true : false}>
            {this.state.brand === "EP" ? <svg id="EP_Icon_-_Question" data-name="EP Icon - Question" xmlns="http://www.w3.org/2000/svg" width="46" height="46" viewBox="0 0 46 46">
              <g id="Group_109" data-name="Group 109" transform="translate(-6)">
                <rect id="rec-46x46" width="46" height="46" transform="translate(6)" fill="none" />
                <path className={`nav-icons ${this.state.option === "question" ? "active" : ""}`} id="Path_26" data-name="Path 26" d="M187.222,1445.366a2.209,2.209,0,0,1-1.434.724,2,2,0,0,1-1.6-.642L181.9,1443.3a9.932,9.932,0,0,1-2.713,1.2,12.938,12.938,0,0,1-3.518.435,11.806,11.806,0,0,1-5.1-.983,9.2,9.2,0,0,1-3.332-2.6,10,10,0,0,1-1.821-3.675,16.347,16.347,0,0,1-.55-4.234v-8.756a17.125,17.125,0,0,1,.238-2.856,12.3,12.3,0,0,1,.766-2.68,10.1,10.1,0,0,1,1.364-2.35,8.581,8.581,0,0,1,2.037-1.873,9.8,9.8,0,0,1,2.782-1.242,14.885,14.885,0,0,1,7.227,0,9.951,9.951,0,0,1,2.8,1.242,8.474,8.474,0,0,1,2.047,1.873,10.414,10.414,0,0,1,1.375,2.35,12.005,12.005,0,0,1,.775,2.68,17.125,17.125,0,0,1,.238,2.856v8.756a15.9,15.9,0,0,1-.4,3.572,10.921,10.921,0,0,1-1.289,3.218l2.311,2.091a2.21,2.21,0,0,1,.569.755,1.894,1.894,0,0,1,.166.809,2.08,2.08,0,0,1-.176.786A2.211,2.211,0,0,1,187.222,1445.366Zm-5.526-20.68a12.731,12.731,0,0,0-.291-2.784,5.9,5.9,0,0,0-.984-2.235,4.734,4.734,0,0,0-1.857-1.48,8.141,8.141,0,0,0-5.8-.01,4.566,4.566,0,0,0-1.835,1.469,5.89,5.89,0,0,0-.964,2.236,13.271,13.271,0,0,0-.279,2.8v8.756a12.776,12.776,0,0,0,.29,2.805,6.079,6.079,0,0,0,.974,2.246,4.614,4.614,0,0,0,1.835,1.491,6.774,6.774,0,0,0,2.872.538,5.011,5.011,0,0,0,2.82-.7l-.954-.89a1.461,1.461,0,0,1-.405-.61,1.836,1.836,0,0,1-.093-.692,1.946,1.946,0,0,1,.177-.694,2.231,2.231,0,0,1,1.544-1.263,1.259,1.259,0,0,1,1.162.279l1.016.807a4.581,4.581,0,0,0,.591-1.5,8.8,8.8,0,0,0,.177-1.812Z" transform="translate(-147.866 -1406.239)" fill="rgba(47,113,172,0.2)" />
              </g>
            </svg>
              :
            <svg id="TB_Icon_-_Question" data-name="TB Icon - Question" xmlns="http://www.w3.org/2000/svg" width="46" height="46" viewBox="0 0 46 46">
              <rect id="rec-46x46" width="46" height="46" fill="none" />
              <path className={`nav-icons ${this.state.option === "question" ? "active" : ""}`} id="Path_26" data-name="Path 26" d="M187.223,1445.368a2.21,2.21,0,0,1-1.434.725,2,2,0,0,1-1.6-.643L181.9,1443.3a9.952,9.952,0,0,1-2.713,1.2,12.945,12.945,0,0,1-3.518.434,11.805,11.805,0,0,1-5.1-.983,9.2,9.2,0,0,1-3.332-2.6,10,10,0,0,1-1.821-3.675,16.347,16.347,0,0,1-.55-4.234v-8.756a17.126,17.126,0,0,1,.238-2.856,12.3,12.3,0,0,1,.766-2.681,10.107,10.107,0,0,1,1.365-2.35,8.581,8.581,0,0,1,2.037-1.873,9.791,9.791,0,0,1,2.782-1.242,14.891,14.891,0,0,1,7.228,0,9.945,9.945,0,0,1,2.8,1.242,8.475,8.475,0,0,1,2.047,1.873,10.416,10.416,0,0,1,1.375,2.35,12.006,12.006,0,0,1,.776,2.681,17.123,17.123,0,0,1,.238,2.856v8.756a15.9,15.9,0,0,1-.4,3.572,10.924,10.924,0,0,1-1.289,3.218l2.311,2.091a2.207,2.207,0,0,1,.569.755,1.892,1.892,0,0,1,.166.808,2.082,2.082,0,0,1-.176.786A2.212,2.212,0,0,1,187.223,1445.368Zm-5.526-20.681a12.734,12.734,0,0,0-.291-2.784,5.9,5.9,0,0,0-.984-2.235,4.737,4.737,0,0,0-1.857-1.481,8.144,8.144,0,0,0-5.8-.01,4.567,4.567,0,0,0-1.835,1.469,5.891,5.891,0,0,0-.964,2.236,13.272,13.272,0,0,0-.279,2.8v8.756a12.777,12.777,0,0,0,.29,2.805,6.078,6.078,0,0,0,.974,2.246,4.613,4.613,0,0,0,1.835,1.49,6.772,6.772,0,0,0,2.872.539,5.01,5.01,0,0,0,2.82-.7l-.954-.89a1.462,1.462,0,0,1-.405-.61,1.835,1.835,0,0,1-.093-.693,1.944,1.944,0,0,1,.177-.694,2.232,2.232,0,0,1,1.544-1.263,1.259,1.259,0,0,1,1.162.279l1.016.807a4.581,4.581,0,0,0,.591-1.5,8.8,8.8,0,0,0,.177-1.812Z" transform="translate(-153.866 -1406.239)" fill="rgba(0,147,224,0.2)" />
            </svg>}
          </Button>

          <Button className={`${this.state.brand} nav-buttons`} data-id="markscheme" onClick={this.switchOption}
            hidden={this.state.showm === 0 ? true : this.state.showm === 1 && this.state.allContent[this.state.currentQuestion]["markscheme"] !== "" ? false : true}>
            {this.state.brand === "EP" ? <svg id="EP_Icon_-_Mark_Scheme" data-name="EP Icon - Mark Scheme" xmlns="http://www.w3.org/2000/svg" width="46" height="46" viewBox="0 0 46 46">
              <rect id="rec-46x46" width="46" height="46" fill="none" />
              <path className={`nav-icons ${this.state.option === "markscheme" ? "active" : ""}`} id="Path_22" data-name="Path 22" d="M216.755,1264.851a16.62,16.62,0,0,1,8.572,2.315,17.334,17.334,0,0,1,6.257,6.257,17.027,17.027,0,0,1,0,17.145,17.329,17.329,0,0,1-6.257,6.256,17.022,17.022,0,0,1-17.145,0,17.327,17.327,0,0,1-6.256-6.256,17.021,17.021,0,0,1,0-17.145,17.332,17.332,0,0,1,6.256-6.257A16.624,16.624,0,0,1,216.755,1264.851Zm0,3.318a13.41,13.41,0,0,0-6.913,1.866,13.941,13.941,0,0,0-5.047,5.046,13.733,13.733,0,0,0,0,13.827,13.938,13.938,0,0,0,5.047,5.047,13.733,13.733,0,0,0,13.827,0,13.944,13.944,0,0,0,5.047-5.047,13.738,13.738,0,0,0,0-13.827,13.947,13.947,0,0,0-5.047-5.046A13.41,13.41,0,0,0,216.755,1268.169Zm9.679,8.987a.862.862,0,0,1,.276.622.658.658,0,0,1-.276.553l-11.891,11.822a.862.862,0,0,1-.622.276.658.658,0,0,1-.553-.276l-6.291-6.292a.86.86,0,0,1-.277-.622.657.657,0,0,1,.277-.553l1.59-1.59a.747.747,0,0,1,.553-.207,1.012,1.012,0,0,1,.622.207l4.079,4.218,9.817-9.748a.743.743,0,0,1,.553-.208.86.86,0,0,1,.621.276Z" transform="translate(-193.61 -1258.851)" fill="rgba(47,113,172,0.2)" />
            </svg>
              :
            <svg id="TB_Icon_-_Mark_Scheme" data-name="TB Icon - Mark Scheme" xmlns="http://www.w3.org/2000/svg" width="46" height="46" viewBox="0 0 46 46">
              <rect id="rec-46x46" width="46" height="46" fill="none" />
              <path className={`nav-icons ${this.state.option === "markscheme" ? "active" : ""}`} id="Path_22" data-name="Path 22" d="M216.755,1264.851a16.62,16.62,0,0,1,8.572,2.315,17.336,17.336,0,0,1,6.257,6.257,17.027,17.027,0,0,1,0,17.145,17.331,17.331,0,0,1-6.257,6.256,17.023,17.023,0,0,1-17.145,0,17.329,17.329,0,0,1-6.256-6.256,17.021,17.021,0,0,1,0-17.145,17.333,17.333,0,0,1,6.256-6.257A16.624,16.624,0,0,1,216.755,1264.851Zm0,3.318a13.413,13.413,0,0,0-6.913,1.866,13.942,13.942,0,0,0-5.047,5.047,13.732,13.732,0,0,0,0,13.827,13.938,13.938,0,0,0,5.047,5.047,13.733,13.733,0,0,0,13.827,0,13.945,13.945,0,0,0,5.047-5.047,13.738,13.738,0,0,0,0-13.827,13.949,13.949,0,0,0-5.047-5.047A13.414,13.414,0,0,0,216.755,1268.17Zm9.679,8.987a.862.862,0,0,1,.276.622.658.658,0,0,1-.276.553l-11.891,11.822a.862.862,0,0,1-.622.276.658.658,0,0,1-.553-.276l-6.291-6.291a.86.86,0,0,1-.277-.622.657.657,0,0,1,.277-.553l1.59-1.59a.748.748,0,0,1,.553-.207,1.013,1.013,0,0,1,.622.207l4.079,4.218,9.817-9.748a.744.744,0,0,1,.553-.208.859.859,0,0,1,.622.276Z" transform="translate(-193.61 -1258.851)" fill="rgba(0,147,224,0.2)" />
            </svg>}
          </Button>

          <Button className={`${this.state.brand} nav-buttons`} data-id="examinerreport" onClick={this.switchOption}
            hidden={this.state.showe === 0 ? true : this.state.showe === 1 && this.state.allContent[this.state.currentQuestion]["examinerreport"] !== "" ? false : true}>
            {this.state.brand === "EP" ? <svg id="EP_Icon_-_Examiner_Remarks" data-name="EP Icon - Examiner Remarks" xmlns="http://www.w3.org/2000/svg" width="46" height="46" viewBox="0 0 46 46">
              <rect id="rec-46x46" width="46" height="46" fill="none" />
              <path className={`nav-icons ${this.state.option === "examinerreport" ? "active" : ""}`} id="Path_23" data-name="Path 23" d="M364.159,1278.742a2.313,2.313,0,1,0,2.312,2.313,2.311,2.311,0,0,0-2.312-2.312m8.093,0a2.313,2.313,0,1,0,2.312,2.313,2.311,2.311,0,0,0-2.312-2.312m8.093,0a2.313,2.313,0,1,0,2.312,2.313,2.31,2.31,0,0,0-2.312-2.312m-20.962,15.571a18.238,18.238,0,0,0,1.438-2.9l.766-2.031L360.1,1287.8a9.935,9.935,0,0,1-2.875-6.749c0-6.373,6.741-11.561,15.03-11.561s15.028,5.188,15.028,11.561-6.74,11.562-15.028,11.562a18.768,18.768,0,0,1-5.666-.875l-1.641-.52-1.409,1a15.46,15.46,0,0,1-4.154,2.094m12.869-28.288c-10.218,0-18.5,6.727-18.5,15.029a13.279,13.279,0,0,0,3.823,9.126,18.384,18.384,0,0,1-3.353,5.289,1.735,1.735,0,0,0,1.264,2.927,17.543,17.543,0,0,0,10.051-3.346,22.316,22.316,0,0,0,6.713,1.033c10.217,0,18.5-6.728,18.5-15.03s-8.279-15.029-18.5-15.029" transform="translate(-348.749 -1259.025)" fill="rgba(47,113,172,0.2)" />
            </svg>
              :
            <svg id="TB_Icon_-_Examiner_Remarks" data-name="TB Icon - Examiner Remarks" xmlns="http://www.w3.org/2000/svg" width="46" height="46" viewBox="0 0 46 46">
              <rect id="rec-46x46" width="46" height="46" fill="none" />
              <path className={`nav-icons ${this.state.option === "examinerreport" ? "active" : ""}`} id="Path_23" data-name="Path 23" d="M364.106,1278.677a2.3,2.3,0,1,0,2.3,2.3,2.3,2.3,0,0,0-2.3-2.3m8.051,0a2.3,2.3,0,1,0,2.3,2.3,2.3,2.3,0,0,0-2.3-2.3m8.051,0a2.3,2.3,0,1,0,2.3,2.3,2.3,2.3,0,0,0-2.3-2.3m-20.855,15.491a18.16,18.16,0,0,0,1.431-2.888l.762-2.021-1.482-1.568a9.883,9.883,0,0,1-2.86-6.714c0-6.34,6.706-11.5,14.952-11.5s14.951,5.161,14.951,11.5-6.706,11.5-14.951,11.5a18.667,18.667,0,0,1-5.637-.87l-1.632-.517-1.4.992a15.388,15.388,0,0,1-4.133,2.083m12.8-28.143c-10.166,0-18.4,6.693-18.4,14.952a13.211,13.211,0,0,0,3.8,9.08,18.287,18.287,0,0,1-3.335,5.262,1.726,1.726,0,0,0,1.257,2.912,17.453,17.453,0,0,0,10-3.329,22.206,22.206,0,0,0,6.679,1.027c10.165,0,18.4-6.693,18.4-14.952s-8.237-14.952-18.4-14.952" transform="translate(-348.749 -1259.025)" fill="rgba(0,147,224,0.2)" />
            </svg>}
          </Button>

          <Button className={`${this.state.brand} nav-buttons`} data-id="notes" onClick={this.switchOption}
            hidden={this.state.shown === 0 ? true : this.state.shown === 1 && this.state.allContent[this.state.currentQuestion]["notes"] !== "" ? false : true}>
            {this.state.brand === "EP" ? <svg id="EP_Icon_-_Notes" data-name="EP Icon - Notes" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="46" height="46" viewBox="0 0 46 46">
              <defs>
                <clipPath id="clipPath">
                  <path id="Path_25" data-name="Path 25" d="M543.519,1267.351h-30.63v30.63h30.63v-30.63" transform="translate(-512.889 -1267.351)" fill="rgba(47,113,172,0.2)" />
                </clipPath>
              </defs>
              <rect id="rec-46x46" width="46" height="46" fill="none" />
              <g id="Group_18" data-name="Group 18" transform="translate(8 8)" clipPath="url(#clipPath)">
                <g id="Group_17" data-name="Group 17" transform="translate(0 0)">
                  <path className={`nav-icons ${this.state.option === "notes" ? "active" : ""}`} id="Path_24" data-name="Path 24" d="M543.519,1288.956a3.168,3.168,0,0,1-.957,2.324l-5.744,5.744a3.164,3.164,0,0,1-2.324.957H516.171a3.267,3.267,0,0,1-3.282-3.282v-24.066a3.266,3.266,0,0,1,3.282-3.282h24.066a3.267,3.267,0,0,1,3.282,3.282Zm-3.282-18.323H516.171V1294.7h15.315v-7.11a1.633,1.633,0,0,1,1.641-1.641h7.11Zm-5.47,23.792,5.2-5.2h-5.2Z" transform="translate(-512.889 -1267.351)" fill="rgba(47,113,172,0.2)" />
                </g>
              </g>
            </svg>
              :
            <svg id="TB_Icon_-_Notes" data-name="TB Icon - Notes" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="46" height="46" viewBox="0 0 46 46">
              <defs>
                <clipPath id="clipPath">
                  <path id="Path_25" data-name="Path 25" d="M543.519,1267.351h-30.63v30.63h30.63v-30.63" transform="translate(-512.889 -1267.351)" fill="rgba(0,147,224,0.2)" />
                </clipPath>
              </defs>
              <rect id="rec-46x46" width="46" height="46" fill="none" />
              <g id="Group_18" data-name="Group 18" transform="translate(8 8)" clipPath="url(#clipPath)">
                <g id="Group_17" data-name="Group 17" transform="translate(0 0)">
                  <path className={`nav-icons ${this.state.option === "notes" ? "active" : ""}`} id="Path_24" data-name="Path 24" d="M543.519,1288.956a3.167,3.167,0,0,1-.957,2.324l-5.744,5.744a3.164,3.164,0,0,1-2.324.957H516.171a3.267,3.267,0,0,1-3.282-3.282v-24.066a3.266,3.266,0,0,1,3.282-3.282h24.066a3.267,3.267,0,0,1,3.282,3.282Zm-3.282-18.323H516.171V1294.7h15.315v-7.11a1.633,1.633,0,0,1,1.641-1.641h7.11Zm-5.47,23.792,5.2-5.2h-5.2Z" transform="translate(-512.889 -1267.351)" fill="rgba(0,147,224,0.2)" />
                </g>
              </g>
            </svg>}
          </Button>
        
          <Button className={`${this.state.brand} nav-buttons`} data-id="resources" onClick={this.switchOption}
            hidden={this.state.showr === 0 ? true : this.state.showr === 1 && this.state.index[this.state.currentQuestion]["res"] !== "" ? false : true}>
            {this.state.brand === "EP" ? <svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" viewBox="0 0 46 46">
              <g id="EP_icon_-_Resources" data-name="EP icon - Resources" opacity="0.997">
                <rect id="rec-46x46" width="46" height="46" fill="none" />
                <path className={`nav-icons ${this.state.option === "resources" ? "active" : ""}`} id="Icon_awesome-paperclip" data-name="Icon awesome-paperclip" d="M2.613,27.384A9.021,9.021,0,0,1,2.7,14.6L15.371,2A6.9,6.9,0,0,1,25.08,2a6.7,6.7,0,0,1,0,9.533L14.031,22.507a4.6,4.6,0,0,1-6.525-.059,4.462,4.462,0,0,1,.088-6.283L16.28,7.54a.986.986,0,0,1,1.367-.014L19.028,8.84a.922.922,0,0,1,.015,1.329l-8.685,8.625a.778.778,0,0,0-.039,1.075.657.657,0,0,0,.948.01L22.316,8.9a3.016,3.016,0,0,0,0-4.277,2.956,2.956,0,0,0-4.179,0L5.462,17.23a5.332,5.332,0,0,0-.072,7.538,5.256,5.256,0,0,0,7.436.017l10.4-10.339a.986.986,0,0,1,1.367-.015l1.382,1.314a.922.922,0,0,1,.015,1.329L15.59,27.412A9.2,9.2,0,0,1,2.613,27.384Z" transform="translate(9 8)" fill="rgba(47,113,172,0.2)" />
              </g>
            </svg>
              :
            <svg id="TB_Icon_-_Resources" data-name="TB Icon - Resources" xmlns="http://www.w3.org/2000/svg" width="46" height="46" viewBox="0 0 46 46">
              <rect id="rec-46x46" width="46" height="46" fill="none" />
              <path className={`nav-icons ${this.state.option === "resources" ? "active" : ""}`} id="Icon_awesome-paperclip" data-name="Icon awesome-paperclip" d="M2.71,28.4A9.354,9.354,0,0,1,2.8,15.141L15.939,2.071a7.152,7.152,0,0,1,10.067,0,6.951,6.951,0,0,1,0,9.885L14.55,23.338a4.768,4.768,0,0,1-6.766-.061,4.627,4.627,0,0,1,.091-6.515l9.006-8.945A1.023,1.023,0,0,1,18.3,7.8l1.432,1.363a.956.956,0,0,1,.015,1.378l-9.005,8.944A.807.807,0,0,0,10.7,20.6a.681.681,0,0,0,.983.01L23.14,9.231a3.127,3.127,0,0,0,0-4.435,3.065,3.065,0,0,0-4.333,0L5.663,17.866a5.529,5.529,0,0,0-.075,7.816,5.45,5.45,0,0,0,7.71.017L24.08,14.979a1.023,1.023,0,0,1,1.418-.016l1.433,1.362a.956.956,0,0,1,.016,1.378L16.166,28.425A9.535,9.535,0,0,1,2.71,28.4Z" transform="translate(9 7)" fill="rgba(0,147,224,0.2)" />
            </svg>}
          </Button>
                    </div>
        
            <iframe title="print" id="printOutputFrame" style={{display : "none"}}></iframe>
      </div>
      );
    }
  }
}

export default App;